module.exports = __webpack_public_path__ + "img/loading.24a8e48.svg";